import {
  CustomAttribute,
  CustomSelectAttributeValue,
  NewCustomAttribute,
  UpdateCustomAttributeRequest,
} from '../../../types';
import { mapClientToServerType } from './constants';
import {
  InternalCreateCustomAttributeRequest,
  InternalCustomAttribute,
  InternalUpdateAttributeRequestDefinition,
} from './types';

const CustomAttributeMigration = {
  buildCreateRequest: (
    newCustomAttribute: NewCustomAttribute,
  ): InternalCreateCustomAttributeRequest => {
    let possibleValues;
    if (
      newCustomAttribute.dataType === 'select' ||
      newCustomAttribute.dataType === 'multi_select'
    ) {
      possibleValues = newCustomAttribute.enumValues.map((value) => ({ name: value }));
    }
    return {
      name: newCustomAttribute.displayName,
      description: newCustomAttribute.description,
      ...(possibleValues && { possibleValues }),
      status: 'active',
      ...mapClientToServerType[newCustomAttribute.dataType],
    };
  },
  buildUpdateRequest: (
    updateCustomAttributeRequest: UpdateCustomAttributeRequest,
  ): InternalUpdateAttributeRequestDefinition => {
    let possibleValues;
    if (
      (updateCustomAttributeRequest.dataType === 'select' ||
        updateCustomAttributeRequest.dataType === 'multi_select') &&
      updateCustomAttributeRequest?.updateValues
    ) {
      possibleValues = {
        newAttributes: updateCustomAttributeRequest?.updateValues?.new,
        deletedAttributes: updateCustomAttributeRequest?.updateValues?.delete,
        updatedAttributes: updateCustomAttributeRequest?.updateValues?.update,
      };
    }

    return {
      ...('displayName' in updateCustomAttributeRequest && {
        name: updateCustomAttributeRequest.displayName,
      }),
      ...('description' in updateCustomAttributeRequest && {
        description: updateCustomAttributeRequest.description,
      }),
      ...('isActive' in updateCustomAttributeRequest && {
        status: updateCustomAttributeRequest.isActive ? 'active' : 'inactive',
      }),
      ...(possibleValues && { possibleValues }),
    };
  },
  convertToCustomAttribute: (internalCustomAttribute: InternalCustomAttribute): CustomAttribute => {
    let enumValues: string[];
    let values: CustomSelectAttributeValue[];
    const common = {
      id: internalCustomAttribute.id,
      displayName: internalCustomAttribute.name,
      description: internalCustomAttribute.description,
      isActive: internalCustomAttribute.status === 'active',
    };
    if (internalCustomAttribute.possibleValues) {
      enumValues = internalCustomAttribute.possibleValues.map(({ name }) => name.toString());
      values = internalCustomAttribute.possibleValues.map(({ id, name }) => ({
        id,
        name: name.toString(),
      }));
      return {
        ...common,
        dataType: internalCustomAttribute.multipleChoice ? 'multi_select' : 'select',
        enumValues,
        values,
      };
    }
    return {
      ...common,
      dataType: internalCustomAttribute.type === 'text' ? 'text' : 'numeric',
    };
  },
  convertToCustomAttributes: (
    internalCustomAttributes: InternalCustomAttribute[],
  ): CustomAttribute[] =>
    internalCustomAttributes.map(CustomAttributeMigration.convertToCustomAttribute),
};
export default CustomAttributeMigration;
